import { Injectable } from '@angular/core';
import { UtilsService } from 'src/app/utils/utils.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { ExtremeWeatherDataService } from '../extreme-weather-data.service';

@Injectable({
  providedIn: 'root'
})
export class WindspeedService {

  constructor(private utilService: UtilsService,private extremeWeatherDataService: ExtremeWeatherDataService) { }

  setWindSpeedData(data, adminSelected, route, location?) {
    let finalData = {};
    let tableData = [];
    let tableDataUnsorted = [];
    for (let item of Object.keys(data)) {
      let object = [];
      let locName = '';
      for (let element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = { val: Number(element['data']['wg']).toFixed(1), blockLength: element['blockLength']};
        }
        else if (element['blockLength'] == 'day') {
          object[element['timeStamp']] = { val: Number(element['data']['wg']).toFixed(1), blockLength: element['blockLength'] };
        } 
        else {
          object[element['timeStamp']] = {val: Number(element['data']['wg']).toFixed(1),blockLength: element['blockLength']};
        }
      }
      if (adminSelected) {
        locName = this.utilService.formatNames(data[item]['name']);
        object[location] = {val: locName};
      } else {
        locName = this.utilService.formatNames(data[item]['name']);
        object['Basin'] = {val: locName};
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (data[item]['uuid'] != undefined && data[item]['uuid'] != null) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataUnsorted.push(object);
    }
    tableData = tableDataUnsorted;
    finalData['data'] = tableData

    let tableColumns = [];
    let cols = this.createColumns(this.setBlockArray(data, route), adminSelected, false,location)
    tableColumns.push(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    // console.log(finalData,"finaldata123");
    return finalData;
  }

  createColumns(columns,adminSelected,isMandal,location?){
    let finalColumns = [];
    if (adminSelected) {
      if (isMandal) {
        finalColumns.push({
          val: 'Mandal',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'Mandal'
        });
      }
      if(location == 'State') {
        finalColumns.push({
          val: 'State',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'State'
        });
      } else if(location == 'District'){
        finalColumns.push({
          val: 'District',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'District'
        });
      }
      else{
        finalColumns.push({
          val: 'Block',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'Block'
        });
      }
    } else {
      if (isMandal) {
        finalColumns.push({
          val: 'Sub Basin',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'SubBasin'
        });
      }
      finalColumns.push({
        val: 'Basin',
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: 'Basin'
      });
    }
    for (const element in columns) {
      finalColumns.push({
        val: columns[element],
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: columns[element]
      });
    }
    return finalColumns;
  }

  createColumnsVillage(columns,adminSelected,isVillage){
    let finalColumns = [];
    if(adminSelected){
      if(isVillage){
        finalColumns.push({
          val : 'Village',
          colspan : 1,
          rowspan : 1,
          sortedHeaderVal : 'Village'
        })
      }
      finalColumns.push({
        val : 'Mandal',
        colspan : 1,
        rowspan : 1,
        sortedHeaderVal : 'Mandal'
      })
    }
    for(let element in columns){
      finalColumns.push({
        val : columns[element],
        colspan : 1,
        rowspan : 1,
        sortedHeaderVal : columns[element]
      })
    }
    return finalColumns;
  }

  setBlockArray(data,route,location?){
    let windSpeedDataKeys;
    for (let item of Object.keys(data)) {
      windSpeedDataKeys = [];
      for (let element of data[item]['table_data']) {
        if (element['blockLength'] == '6hr') {
          windSpeedDataKeys.push(element['timeStamp']);
        } else if (element['blockLength'] == '24hr') {
            windSpeedDataKeys.push('24hr');
        } else {
            windSpeedDataKeys.push(element['timeStamp']);
        }
      }
    }
    return this.sortKeys(windSpeedDataKeys,route);
  }

  setMandalData(data,adminSelected,route) {
    let finalData = {};
    let tableDataMandal = [];
    for (let item of Object.keys(data)) {
      let object = [];
      let locName = '';
      let pName = '';
      if (adminSelected) {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Mandal'] = {
          val : locName };
        object['District'] = {
          val : pName};
      } else {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Sub Basin'] = {
          val : locName};
        object['Basin'] = {
          val : pName};
      }
      for (let element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
            object['24hr'] = {
              val : Number(element['data']['wg']).toFixed(1)};
        } else {
          object[element['timeStamp']] = { val : Number(element['data']['wg']).toFixed(1)};
        }
      }
      if(data[item]['centroid'] != undefined && data[item]['centroid'] != null){
        object['centroid'] = data[item]['centroid'];
      }
      if(data[item]['uuid'] != undefined && data[item]['uuid'] != null) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataMandal.push(object);
    }
    finalData['data'] = tableDataMandal

    let tableColumns = [];
    let cols = this.createColumns(this.setBlockArray(data,route),adminSelected,true)
    tableColumns.push(cols);
    // console.log(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  setVillageData(data,adminSelected,route) {
    let finalData = {};
    let tableDataMandal = [];
    for (let item of Object.keys(data)) {
      let object = [];
      let locName = '';
      let pName = '';
      pName = this.utilService.formatNames(data[item]['pName']);
      locName = this.utilService.formatNames(data[item]['name']);
      object['Village'] = {
        val : locName };
      object['Mandal'] = {
        val : pName};
      for (let element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
            object['24hr'] = {
              val : Number(element['data']['wg']).toFixed(1)};
        } else {
          object[element['timeStamp']] = { val : Number(element['data']['wg']).toFixed(1)};
        }
      }
      if(data[item]['centroid'] != undefined && data[item]['centroid'] != null){
        object['centroid'] = data[item]['centroid'];
      }
      if(data[item]['uuid'] != undefined && data[item]['uuid'] != null) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataMandal.push(object);
    }
    finalData['data'] = tableDataMandal

    let tableColumns = [];
    let cols = this.createColumnsVillage(this.setBlockArray(data,route),true,true)
    tableColumns.push(cols);
    // console.log(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  sortByAlpha(array: any, adminSelected): any {
    var temp: any;
    for (var i = 0; i < array.length; i++) {
      for (var j = i + 1; j < array.length; j++) {

        if (adminSelected && array[i]['Mandal'] > array[j]['Mandal']) {
          temp = array[i];
          array[i] = array[j];
          array[j] = temp;
        } else if (!adminSelected && array[i]['Sub Basin'] > array[j]['Sub Basin']) {
          temp = array[i];
          array[i] = array[j];
          array[j] = temp;
        }
      }
    }
    return array;
  }

  setChartData(data,ProjConstants){
    let keys = Object.keys(data);
    let formattedChartData = [];
    for (let key of keys) {
      let obj = {};
      for (let item of Object.keys(data[key])) {

        if (item == '6hr') {
          let timeStamps = Object.keys(data[key][item]);
          for (let timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        } else if (item == '24hr') {
          let timeStamps = Object.keys(data[key][item]);
          for (let timestamp of timeStamps) {
              obj['24hr'] = data[key][item][timestamp];
          }
        } else {
        let timeStamps = Object.keys(data[key][item]);
          for (let timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        }
      }
      obj[ProjConstants.CHART_DATA_COLUMNS['WINDSPEED']] = key;
      formattedChartData.push(obj);
    }
    return formattedChartData;
  }

  formatDataForChart(data) {
    let chartData = {};
    for (let range of Object.keys(data)) {
      let obj = {};
      for (let item of Object.keys(data[range])) {
        if (item == '6hr') {
          let timeStamps = Object.keys(data[range][item]);
          for (let timestamp of timeStamps) {
            obj[timestamp] = data[range][item][timestamp];
          }
        } else if (item == '24hr') {
          let timeStamps = Object.keys(data[range][item]);
          for (let timestamp of timeStamps) {
              obj['24hr'] = data[range][item][timestamp];
          }
        }
        else{
          let timeStamps = Object.keys(data[range][item]);
          for (let timestamp of timeStamps) {
            obj[timestamp] = data[range][item][timestamp];
          }
        }
      }
      chartData[range] = obj;
    }
    return chartData;
  }

  sortKeys(data,route) {
    let returnArray = [];
    let dummyArray = [];
    for (let timestamp of data) {

      if (route.snapshot.paramMap.get('time') == '24' && timestamp == '24hr') {
        returnArray.push(timestamp);
      } else {
        dummyArray.push(timestamp);
      }
    }
    dummyArray = dummyArray.sort();
    for (let ele of dummyArray) {
      returnArray.push(ele);
    }
    return returnArray;
  }

  get24HrsTimeStamps(source) {
    // ---------------33435 IMD Block---------------
    let hoursIncrement = 0;
    let startHour = 8;
    // if (source == 'IMD') {
    //   hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    //   startHour = 8;
    // }
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(startHour, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 10800000);
    let startTimestamp = this.extremeWeatherDataService.getCurrentBlockTs(dayStartTs) 
    const blocks = {};
    for (let i = 0; i < 8; i++) {
      blocks[i] = {};
      // blocks[i]['timeStamp'] = dayStartTs + ((i + blockIndex) * 10800000);
      blocks[i]['timeStamp'] = startTimestamp + ((i * 10800000));      
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['label'] = this.convertTimestampToBlockValue(blocks[i]['timeStamp']);
      blocks[i]['leftSideName'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    let index = this.getCurrentBlockIndex(blocks)
    blocks[8] = {};
    blocks[8]['timeStamp'] = blocks[index]['timeStamp'];
    blocks[8]['timeLineName'] = {};
    blocks[8]['timeLineName']['toolTip'] = this.convertTimestampToBlockValue(blocks[index]['timeStamp']) + '-' + this.convertTimestampToBlockValue(blocks[index]['timeStamp']);
    blocks[8]['timeLineName']['label'] = '24hr';
    blocks[8]['leftSideName'] = '24hr';
    blocks[8]['timeLinePos'] = 8;    
    return blocks;
  }

  getCurrentBlockIndex(blocks) {
    const currentTime = new Date().getTime();
    let currentBlockIndex:any = 0; // Default value if not found
  
    for (const index in blocks) {
      const blockStartTime = blocks[index].timeStamp;
      const blockEndTime = blockStartTime + 3 * 60 * 60 * 1000; // 3 hours in milliseconds
  
      if (currentTime >= blockStartTime && currentTime < blockEndTime) {
        currentBlockIndex = index;
        break;
      }
    }
  
    return currentBlockIndex;
  }

  get10DaysTimeStamps(source,timestamp){
    // ---------------33435 IMD Block---------------
    let hoursIncrement = 0;
    let startHour;
    if(timestamp.endsWith('00')) {
      startHour = 8
    } else {
      startHour = 20
    }    // if (source == 'IMD') {
    //   // hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    //   startHour = 8
    // }
    var today = new Date();
    let refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    var start = new Date(refTs);
    start.setHours(startHour,30,0,0);
    let dayStartTs = start.getTime();
    let blockIndex = Math.floor((refTs - dayStartTs) / 21600000);
    let blocks = {}
    for(let i=0;i<28;i++){
      blocks[i] = {}
      // blocks[i]['timeStamp'] = dayStartTs + ((i + blockIndex) * 21600000);
      blocks[i]['timeStamp'] = dayStartTs + (((i + blockIndex) * 21600000) - hoursIncrement);
      if((i + blockIndex)%4==0 || (i==0 && blockIndex <3)){
        blocks[i]['timeLineName'] = {}
        blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']+hoursIncrement);
        blocks[i]['timeLineName']['label'] = this.convetTimeStampToDay(blocks[i]['timeStamp']+hoursIncrement);
      }
      else{
        blocks[i]['timeLineName'] = {}
        blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']+hoursIncrement);
        blocks[i]['timeLineName']['label'] = "";
      }
      blocks[i]['leftSideName'] = this.getDay(blocks[i]['timeStamp']) + "-" + this.getMonth(blocks[i]['timeStamp']) + "-" + this.getYear(blocks[i]['timeStamp']) + " " + this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']+hoursIncrement);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks;
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
      let hours = new Date(ts).getHours();
      let minutes = new Date(ts).getMinutes();
      let amPm = "A.M";
      if(hours>12){
        hours = hours - 12;
        amPm = "P.M";
      }
      return hours.toString() + ":" + minutes.toString() + " " + amPm;
  }

  convertTimestampToBlockValueSpace(ts) {
  ts = Number(ts);
    let hours = new Date(ts).getHours();
    let minutes = new Date(ts).getMinutes();
    let amPm = "A.M";
    if(hours>12){
      hours = hours - 12;
      amPm = "P.M";
    }
    return hours.toString() + ":" + minutes.toString() + "" + amPm;
  }

  convetTimeStampToDay(ts){
    let date = new Date(ts).toLocaleDateString();
    return date;
  }

  convertTimestampToFullBlockValue(ts) {
    ts = Number(ts);
      let starthours = new Date(ts).getHours();
      let startminutes = new Date(ts).getMinutes();
      let startamPm = "A.M";
      if(starthours>12){
        starthours = starthours - 12;
        startamPm = "P.M";
      }
      let endhours = new Date(ts + ProjConstants.MILLS_IN_3HOURS).getHours();
      let endminutes = new Date(ts + ProjConstants.MILLS_IN_3HOURS).getMinutes();
      let endamPm = "A.M";
      if(endhours>12){
        endhours = endhours - 12;
        endamPm = "P.M";
      }
      return starthours.toString() + ":" + startminutes.toString() + " " + startamPm + " - " +  endhours.toString() + ":" + endminutes.toString() + " " + endamPm;
  }

  getDay(ts){
    ts = Number(ts);
    let day = new Date(ts).getDate();
    /* if(day == 1){
      return day.toString() + "st";
    }
    else if(day == 2){
      return day.toString() + "nd";
    }
    else if(day == 3){
      return day.toString() + "rd";
    }
    else {
      return day.toString() + "th";
    } */

    return (day < 10 ? '0' : '') + day.toString();
  }

  getMonth(ts){
    ts = Number(ts);
    //return new Date(ts).toLocaleString('default', { month: 'short' })
    let month =  new Date(ts).getMonth();
    return  (month +1 < 10 ? '0' : '') + (month+1).toString();
  }

  getYear(ts){
    ts = Number(ts);
    return new Date(ts).getFullYear().toString().substr(-2);
  }
}
